var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isShowMain)?_c('div',[_c('router-view',{key:_vm.$route.fullPath})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }